import React from "react";
import { connect } from "react-redux";
import moment from "moment";
// import { Link } from "react-router-dom";

import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import {
	Table,
	Button,
	Modal,
	Icon,
	Form,
	Input,
	message,
	DatePicker,
	TimePicker,
	Select,
	TreeSelect,
	Spin,
	Radio,
	Col,
	Row,
	Tag,
	Tabs,
	Tooltip
} from 'antd';
import { fetchAttendanceRecord, updateAttendanceRecord, exportAttendanceRecord, exportAttendanceExceptionRecord, fetchAttendanceSchedule, fetchExceptionAttendanceRecord, updateCrewRostering } from '../../actions/attendance-actions';
import { fetchDepartmentsList, reviewAttendanceRecord } from '../../actions/department-structure-actions.js';
import attendanceRecordService from '../../services/Attendance/attendance-record-service';
import rosterService from '../../services/EmployeeManagement/roster-service';
import { fetchEmployeesList } from '../../actions/employee-management-actions.js';
import crewRosteringListService from '../../services/Attendance/crew-rostering-service.js'

const FormItem = Form.Item;
const { TextArea } = Input;
const dateFormat = "YYYY-MM-DD";
const { TreeNode } = TreeSelect;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const { RangePicker } = DatePicker;
const Option = Select.Option;
class AttendanceRecord extends React.Component {

	constructor(props) {
		super(props);
		this.componentDidMount = this.componentDidMount.bind(this);
		this.state = {
			isloading2: false,
			department_ids: null,
			currentSchedule: false,
			all_members: 'true',
			scheduleList: [],
			schedule_id: null,
			tab: 'tab0',
			makeupStatus: false,
			managementModalStatus: false,
			currentScheduleModalStatus: false,
			typeTag: 3,
			schedule_user_ids:[],
			makeupModel: {
				id: null,
				ids: null,
				employee_id: null,
				employee_ids: null,
				record_date: null,
				management_on_time: null,
				management_off_time: null,
				supplement_on_time: null,
				supplement_off_time: null,
				off_time: null,
				supplement_reason: '',
				remark: null,
				record_dates: null
			},
			MakeupColletion: {
				department_id: null,
				department_users: [],
				reason_list: [],
				addnew: true,
				disable_start: false,
				disable_end: false,
			},
			exceptionFilter: {
				page: 1,
				campus: ''
			},
			attendanceDepartment: null,
			currentData: {}
		}
	}

	changeBan(value) {

		this.setState({ schedule_id: value })

	}


	closeCurrentSchedule() {
		this.setState({ currentSchedule: false });
	}


	postCurrentSchedule() {
		if (this.state.currentScheduleData === undefined) {
			message.error("请选择日期范围");
			return false
		}
		if (this.state.schedule_id === null) {
			message.error("请选择班次");
			return false
		}
		var params = {
			start_date: this.state.currentScheduleData[0],
			end_date: this.state.currentScheduleData[1],
			department_id: this.state.attendanceDepartment,
			employee_ids:this.state.schedule_user_ids,
			schedule_id: this.state.schedule_id,
			update_attendance_type:this.state.typeTag
		}
		attendanceRecordService.updateScheduleCustom(params, res => {
			if (res.data.Success) {
				message.success('更新班次成功', 4);
				this.setState({ currentSchedule: false })
				this.props.fetchAttendanceRecord()
			} else {
				message.error("更新班次失败, " + res.data.Errors[0], 4)
			}
		}, res => message.error("更新班次失败", 4))


	}


	currentScheduleDataChange(date, dateString) {


		this.setState({ currentScheduleData: dateString })


	}


	componentWillMount() {
		this._fetchDepartmentsList()
	}
	componentDidMount() {
		this.props.fetchAttendanceSchedule();
		attendanceRecordService.fetchHRAttendanceSchedule(res => {
			this.setState({ scheduleList: res.data.Data });
		})
	}
	_fetchDepartmentsList = (params) => {
		this.props.fetchDepartmentsList(params);
	}
	updateCurrent = index => {
		this.setState({
			currentModalStatus: true
		});
		// update
		this.setState({
			currentData: this.props.attendance.attendanceRecordData[index]
		});
		this.setState({
			currentIndex: index
		});
	}
	renderTreeNodes = (data) => {
		return data.map((item) => {
			if (item.children) {
				return (
					<TreeNode title={item.name} value={`${item.id}`} key={item.id} dataRef={item}>
						{item.children.length !== 0 && this.renderTreeNodes(item.children)}
					</TreeNode>
				);
			}
			return <TreeNode {...item} />;
		});
	}

	closeCurrentModal = () => {
		this.setState({
			currentModalStatus: false
		});
	}
	submitCurrentModal = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				let posts = {
					...values
				};
				if (values.on_time) {
					posts.on_time = values.on_time.format('HH:mm:ss')
				}
				if (values.off_time) {
					posts.off_time = values.off_time.format('HH:mm:ss')
				}
				if (null !== this.state.currentIndex) {
					posts.id = this.state.currentData.id;
					this.props.updateAttendanceRecord(posts, this.state.currentIndex, status => {
						this.props.fetchAttendanceRecord();
						if (status) {
							message.success("考勤记录修改成功", 4);
						} else {
							message.error("考勤记录修改失败", 4);
						}
					});
				}
				this.closeCurrentModal();
			}
		})
	}
	setMonthFilter = (val) => {
		if (val) {
			val = val.format(dateFormat)
			this.setState({ export_date: val });
		}
		else {
			this.setState({ export_date: '' });
		}
	}
	exportAttendanceRecord() {

		let gets = {};
		for (let key in this.state) {
			if (this.state[key] !== undefined && key !== 'scheduleList' && key !== 'makeupModel' && key !== 'MakeupColletion') {
				gets[key] = this.state[key];
			}
		}
		this.props.exportAttendanceRecord(gets)
	}

	exportAttendanceExceptionRecord() {
		let gets = { ...this.state.exceptionFilter };
		this.props.exportAttendanceExceptionRecord(gets)
	}
	setUploadedFile = event => {
		this.setState({ uploadedFile: event.target.files[0] });
	}

	downloadTemplate = gets => {
		let ref = Modal.info({
			content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"
		});
		attendanceRecordService.downloadTemplate(gets, res => {
			ref.destroy();
			if (res.data.Success) {
				window.open(res.data.Message);
			} else {
				message.error('下载模版失败, ' + res.data.Errors[0], 4);
			}
		}, err => message.error('下载模版失败', 4));
	}

	uploadFile = () => {
		if (this.state.uploadedFile) {
			let ref = Modal.info({ content: "正在导入文件, 请稍后..." });
			let formData = new FormData();
			formData.append("uploadedFile", this.state.uploadedFile);
			attendanceRecordService.importAttendanceRecord(formData, res => {
				ref.destroy();
				if (res.data.Success) {
					message.success('导入文件成功', 4);
					this.setState({ importModal: false });
					this.props.fetchAttendanceRecord();
					if (res.data.Object) {
						window.open(res.data.Object);
					}
				} else {
					message.error("导入文件失败, " + res.data.Errors[0], 4)
				}
			}, err => message.error("导入文件失败", 4));
		} else {
			message.error("请选择需要导入的文件", 4);
		}
	}

	showCurrentSchedule = () => {

		this.setState({ currentSchedule: true, attendanceDepartment: null, })

	}


	setEmployeeFilter = (value) => {
		let params = {
			employee_name: value,
			page:1
		}
		let gets = {};
		for (let key in this.state) {
			if (this.state[key] !== undefined && key !== 'scheduleList' && key !== 'makeupModel' && key !== 'MakeupColletion') {
				gets[key] = this.state[key];
			}
		}
		gets = { ...gets, ...params }
		this.setState(params);
		this.props.fetchAttendanceRecord(gets)
	}

	setEmployeeFilter2 = (value) => {
		this.setState({ isloading2: true });
		let params = {
			employee_name: value,
			page:1
		}
		let gets = {};
		gets = { ...this.state.exceptionFilter, ...params }
		this.setState({ exceptionFilter: gets });
		this.props.fetchExceptionAttendanceRecord(gets);
		this.setState({ isloading2: false });
	}

	handleDatePickerStartChange = (val) => {
		let params = {}
		if (val) {
			params.search_start_time = val.format(dateFormat)
		}
		else {
			params.search_start_time = null
		}




		let gets = {};
		for (let key in this.state) {
			if (this.state[key] !== undefined && key !== 'scheduleList' && key !== 'makeupModel' && key !== 'MakeupColletion') {
				gets[key] = this.state[key];
			}
		}
		gets = { ...gets, ...params }
		this.setState(params);
		//this.props.fetchAttendanceRecord(gets)
	}

	//异常处理开始时间
	handleDatePickerStartChange2 = (val) => {
		let params = {}
		if (val) {
			params.search_start_time = val.format(dateFormat)
		}
		else {
			params.search_start_time = null
		}

		let gets = {};

		gets = { ...this.state.exceptionFilter, ...params }
		this.setState({ exceptionFilter: gets });
		//this.props.fetchExceptionAttendanceRecord(gets);
	}

	handleDatePickerEndChange = (val) => {
		let params = {}
		if (val) {
			params.search_end_time = val.format(dateFormat)
		}
		else {
			params.search_end_time = null
		}

		let gets = {};
		for (let key in this.state) {
			if (this.state[key] !== undefined && key !== 'scheduleList' && key !== 'makeupModel' && key !== 'MakeupColletion') {
				gets[key] = this.state[key];
			}
		}
		gets = { ...gets, ...params }
		this.setState(params);
		//this.props.fetchAttendanceRecord(gets)
	}
	//异常处理结束时间
	handleDatePickerEndChange2 = (val) => {
		let params = {}
		if (val) {
			params.search_end_time = val.format(dateFormat)
		}
		else {
			params.search_end_time = null
		}

		let gets = {};

		gets = { ...this.state.exceptionFilter, ...params }
		this.setState({ exceptionFilter: gets });
		//this.props.fetchExceptionAttendanceRecord(gets);
	}

	reviewAttendanceRecord(recode) {
		let export_date = this.state.export_date
		if (export_date) {
			let params = { "organization_id": "", "year": export_date.split("-")[0], "month": export_date.split("-")[1], "audit_result": 1 };

			this.props.reviewAttendanceRecord(params, res => {
				if (res.data.Success) {
					message.success("审核成功", 4);
				} else {
					message.error("审核失败", 4);
				}
			});
		}
		else {
			message.error('年月不能为空', 4);
		}
	}

	onSelectTreeChange(id) {
		let params = {
			department_id: id,
			page: 1
		}
		let gets = {};
		for (let key in this.state) {
			if (this.state[key] !== undefined && key !== 'scheduleList' && key !== 'makeupModel' && key !== 'MakeupColletion') {
				gets[key] = this.state[key];
			}
		}
		gets = { ...gets, ...params }
		this.setState(params);
		//this.props.fetchAttendanceRecord(gets)
	}
	onSelectTreeChange2(id) {
		let params = {
			department_id: id,
			page: 1
		}
		let gets = {};

		gets = { ...this.state.exceptionFilter, ...params }
		this.setState({ exceptionFilter: gets });
		//	this.props.fetchExceptionAttendanceRecord(gets);
	}


	fetchAttendanceRecord = (pagination, filters, sorter) => {
		let params = {
			page: pagination.current,
			order_property: sorter.field,
			is_order_asc: sorter.order !== "descend"
		}
		let gets = {};
		for (let key in this.state) {

			if (this.state[key] !== undefined && key !== 'scheduleList' && key !== 'makeupModel' && key !== 'MakeupColletion') {
				gets[key] = this.state[key];
			}
		}
		gets = { ...gets, ...params }
		this.setState(params);
		this.props.fetchAttendanceRecord(gets)
	}

	fetchExceptionAttendanceRecord = (pagination, filters, sorter) => {
		let params = {
			page: pagination.current,
			order_property: sorter.field,
			is_order_asc: sorter.order !== "descend"
		}
		let gets = {};

		gets = { ...this.state.exceptionFilter, ...params }
		this.setState({ exceptionFilter: gets });
		this.props.fetchExceptionAttendanceRecord(gets)
	}


	onSelectStatusChange(val) {
		let params = {
			job_status: val
		}
		let gets = {};
		for (let key in this.state) {
			if (this.state[key] !== undefined && key !== 'scheduleList' && key !== 'makeupModel' && key !== 'MakeupColletion') {
				gets[key] = this.state[key];
			}
		}
		gets = { ...gets, ...params }
		this.setState(params);
		//this.props.fetchAttendanceRecord(gets)

	}

	onSelectAttendanceStatusChange(val) {
		this.setState({ exceptionFilter: { ...this.state.exceptionFilter, attendance_status: val } });
	}

	showMakeupNew = () => {
		this.setState({
			MakeupColletion: {
				...this.state.MakeupColletion,
				addnew: true
			}
		})
		this.showMakeup();
	}
	showMakeupE = (recored) => {
		this.setState({
			makeupModel: {
				...this.state.makeupModel,
				id: recored.id,
				ids: [recored.id],
				employee_id: recored.employee_id,
				employee_ids: [recored.employee_id],
				record_date: moment(recored.record_date).format(dateFormat),
				on_time: recored.on_time ? recored.record_date + " " + recored.on_time : null,
				off_time: recored.off_time ? recored.record_date + " " + recored.off_time : null,
				management_on_time: recored.management_on_time ? recored.record_date + " " + recored.management_on_time : null,
				management_off_time: recored.management_off_time ? recored.record_date + " " + recored.management_off_time : null,
				supplement_reason: this.state.makeupModel.supplement_reason ? this.state.makeupModel.supplement_reason : (recored.supplement_reason ? recored.supplement_reason : ""),
				remark: recored.remark

			},
			MakeupColletion: {
				...this.state.MakeupColletion,
				id: recored.id,
				disable_start: !!recored.on_time,
				disable_end: !!recored.off_time,
				addnew: false
			}
		}, () => {
			this.showMakeup()
		})
	}

	showMakeup = () => {
		if (!this.state.makeupModel.employee_ids) {
			message.error("请选择要补录的数据");
			return;
		}
		//判断是否选择的同一个日期
		if (this.state.makeupModel.record_dates) {
			const selecteddate = this.state.makeupModel.record_dates[0];
			let ismakeup = true;
			this.state.makeupModel.record_dates.map(m => {
				if (m != selecteddate) {
					message.error("请选择相同日期的数据");
					ismakeup = false;
				}
			})
			if (!ismakeup) return;
		}
		this.setState({
			makeupStatus: true,
		})
		if (this.state.MakeupColletion.reason_list.length === 0) {
			attendanceRecordService.getMakeupReason({}, res => {
				this.setState({
					MakeupColletion: {
						...this.state.MakeupColletion,
						reason_list: res.data.Object.supplementReasonList
					}
				})
			})
		}
	}
	showMakeup2 = () => {
		this.setState({ isadmin: true });
		this.showMakeup();
	}
	cancelMakeup = () => this.setState({
		makeupStatus: false,
		makeupModel: {
			id: null,
			employee_id: null,
			record_date: null,
			on_time: null,
			off_time: null,
			management_on_time: null,
			management_off_time: null,
			supplement_reason: null,
			remark: null
		},
		MakeupColletion: {
			...this.state.MakeupColletion,
			department_id: null,
			department_users: [],
			addnew: true,
			disable_start: false,
			disable_end: false,
		}
	})

	setMakeupDepartment = value => {
		this.setState({
			MakeupColletion: {
				...this.state.MakeupColletion,
				department_id: value
			}
		})

		//获取人员
		var para = {
			department_id: value,
			page_size: 100000,
			page: 1
		}
		rosterService.fetchEmployeesListAll(para, res => {
			this.setState({
				MakeupColletion: {
					...this.state.MakeupColletion,
					department_users: res.data.Data
				}
			})
		})
	}
	setMakeupEmpolyee = (value, employee) => {
		let employee_ids = [];
		employee.forEach(e => {
			if (e.props.employee_id) {
				employee_ids.push(e.props.employee_id)
			}
		})
		this.setState({
			makeupModel: {
				...this.state.makeupModel,
				employee_ids: employee_ids
			}
		})
	}
	setMakeupDate = value => {
		this.setState({
			makeupModel: {
				...this.state.makeupModel,
				record_date: moment(value).format(dateFormat)
			}
		})
	}
	setMakeupOnTime = value => {
		console.log(value);
		this.setState({
			makeupModel: {
				...this.state.makeupModel,
				on_time: value.format("YYYY-MM-DD HH:mm:ss")
			}
		})
	}
	setMakeupOffTime = value => {
		this.setState({
			makeupModel: {
				...this.state.makeupModel,
				off_time: value.format("YYYY-MM-DD HH:mm:ss")
			}
		})
	}
	setMakeupManagementOnTime = value => {
		this.setState({
			makeupModel: {
				...this.state.makeupModel,
				management_on_time: value.format("YYYY-MM-DD HH:mm:ss")
			}
		})
	}
	setMakeupManagementOffTime = value => {
		this.setState({
			makeupModel: {
				...this.state.makeupModel,
				management_off_time: value.format("YYYY-MM-DD HH:mm:ss")
			}
		})
	}


	setMakeupReason = value => {
		this.setState({
			makeupModel: {
				...this.state.makeupModel,
				supplement_reason: value
			}
		})
	}
	setMakeupRemark = event => {
		this.setState({
			makeupModel: {
				...this.state.makeupModel,
				remark: event.target.value
			}
		})
	}
	rowSelection = {

		onChange: (selectedRowKeys, selectedRows) => {
			if (selectedRows.length > 0) {
				this.state.makeupModel.record_date = selectedRows[0].record_date
			}
			let empIds = selectedRows.map(row => row.employee_id);
			let ids = selectedRows.map(row => row.id);
			let record_dates = selectedRows.map(row => row.record_date);
			// this.setState({selectedEmpIDs: empIds});
			this.setState({ makeupModel: { ...this.state.makeupModel, employee_ids: empIds, ids: ids, record_dates: record_dates } })

		}
	}



	saveMakeup = () => {
		console.log(this.props);
		var para = this.state.makeupModel;
		console.log(para)
		para.supplement_on_time = para.on_time ? para.on_time : null;
		para.supplement_off_time = para.off_time ? para.off_time : null;
		para.management_on_time = para.management_on_time ? para.management_on_time : null;
		para.management_off_time = para.management_off_time ? para.management_off_time : null;
		para.isadmin = this.state.isadmin;

		attendanceRecordService.updateBatchMakeup(para, res => {
			console.log(this.state.tab);
			if (res.data.Success) {
				message.success("补录成功")

				if (this.state.tab == 'tab0') {
					let gets = {};
					for (let key in this.state) {
						if (this.state[key] !== undefined && key !== 'scheduleList' && key !== 'makeupModel' && key !== 'MakeupColletion') {
							gets[key] = this.state[key];
						}
					}
					this.props.fetchAttendanceRecord(gets)
				} else if (this.state.tab == 'tab1') {

					this.props.fetchExceptionAttendanceRecord(this.state.exceptionFilter);
				}
				this.cancelMakeup();
			}
			else {
				if (res.data.Errors) {
					message.error(res.data.Errors[0]);
				}
				else {
					message.error("服务器错误");
				}
			}
		}, err => {
			message.error("服务器错误");
		})
	}

	selectEmployee = value => this.props.fetchEmployeesList({ real_name: value })

	changeSchedule = value => this.props.fetchAttendanceSchedule({ search_text: value })

	selectSchedule = value => this.setState({ schedule_id: value })

	selectManagementSchedule = value => {
		this.crewRosteringId = value
		this.setState({ currentData: { ...this.state.currentData, schedule_id: value } })
	}

	changeAttendanceDepartment = department_id => this.setState({ attendanceDepartment: department_id })

	//切换校区加载对应部门
	setCampusFilter = value => {
		//加载当前校区下的部门
		this.props.fetchDepartmentsList({ campus: value });
		//查询
		let params = {
			campus: value,
			department_id: null,
			page: 1
		}
		let gets = {};
		for (let key in this.state) {
			if (this.state[key] !== undefined && key !== 'scheduleList' && key !== 'makeupModel' && key !== 'MakeupColletion') {
				gets[key] = this.state[key];
			}
		}
		gets = { ...gets, ...params }
		//this.setState(params, this.props.fetchAttendanceRecord(gets));
		this.setState(params);

	}
	setCampusFilter2 = value => {
		//加载当前校区下的部门
		this.props.fetchDepartmentsList({ campus: value });
		//查询
		let params = {
			campus: value,
			page: 1,
			department_id: null
		}
		let gets = {};

		gets = { ...this.state.exceptionFilter, ...params }
		this.setState({ exceptionFilter: gets });
		//this.props.fetchExceptionAttendanceRecord(gets);
	}
	changeTabs = (value) => {
		this.setState({ tab: value });
		if (value == "tab0") {
			if (!this.state.department_id && !this.state.campus)
				this.props.fetchDepartmentsList({ campus: this.state.campus });
		}
	}
	//打开班次修改modal
	updateManagementCurrent = (value) => {
		//获取当前班次数据
		if (value) {
			crewRosteringListService.fetchCrewRosteringDetail({ modelId: value }, result => {
				console.log(result)
				this.setState({ currentData: result.data });
				this.setState({ managementModalStatus: true });
			})
		}
	}
	//关闭班次修改modal
	closeManagementCurrent = () => {
		this.setState({ managementModalStatus: false });
	}

	changeManagementSchedule = value => {
		this.props.fetchAttendanceSchedule({ search_text: value })
	}
	//提交班次修改
	submitManagementCurrentModal = () => {
		// submit
		let posts = {
			// ...values
			...this.state.currentData
		};
		if (null !== this.state.currentIndex) {
			posts.id = this.state.currentData.id;
			posts.attendance_day = this.state.currentData.attendance_day;
			posts.attendance_month = this.state.currentData.attendance_month;
			posts.attendance_year = this.state.currentData.attendance_year;
			posts.schedule_id = this.state.currentData.schedule_id
			this.props.updateCrewRostering(posts, this.state.currentIndex, status => {
				this.props.fetchExceptionAttendanceRecord(this.state.exceptionFilter);
				if (status) {
					message.success("修改排班管理成功", 4);
					this.closeManagementCurrent();
				} else {
					message.error("修改排班管理失败", 4);
				}
			});
		}
		this.closeCurrentModal();
	}


	handleSyncAttendanceDateChange = (val) => {
		if (val) {
			this.setState({ sync_attendance_date: val.format(dateFormat) });
		}
	}

	syncAttendanceRecord = () => {
		attendanceRecordService.syncAttendanceRecord({ date: this.state.sync_attendance_date }, res => {
			message.success(res.data.Message);
		})
	}

	//统一设置休息日
	adjustSchedule = () => {
		this.setState({ currentScheduleModalStatus: true });
	}
	//关闭排班统一修改modal
	closeScheduleCurrent = () => {
		this.setState({ currentScheduleModalStatus: false });
	}
	submitCurrentScheduleModal = () => {
		this.props.form.validateFields((err, values) => {
			values.start_time = values.start_time.format('HH:mm');
			values.end_time = values.end_time.format('HH:mm');
			this.props.updateSchedule(values, status => {
				this.props.fetchAttendanceRecord();
				if (status) {
					message.success("设置休息日成功", 4);
				} else {
					message.error("设置休息日失败", 4);
				}
			});
			this.closeScheduleCurrent();

		})
	}
	changeAllMember = (v) => {
		this.setState({
			typeTag: v.target.value
		})
	}
	handleSearchChange = value => this.props.fetchEmployeesList({ real_name: value })


	handleSelectChange = (v) => {
		this.setState({
			schedule_user_ids: v
		})
	}
	render() {
		const { departmentsList } = this.props.departmentStructure;
		const format = 'HH:mm:ss';
		const columns = [
			{
				title: '操作',
				dataIndex: 'action',
				key: 'action',
				className: "table-global-head-small",
				render: (text, record, index) => this.props.access.attendanceRecord.u_value &&
					<div>

						<Button icon="edit" size="small" className="row-action-btn" disabled={!record.can_retroactive && !this.props.webCurrentUser.currentUser.IsAdmin} onClick={this.showMakeupE.bind(this, record)}>补录</Button>  </div>

			},
			{
				title: '工号',
				dataIndex: 'job_number',
				key: 'job_number',
				className: "table-global-head-small",
				sorter: false
			}, {
				title: '中文名',
				dataIndex: 'employee_name',
				key: 'employee_name',
				className: "table-global-head-small	",
				sorter: false
			}, {
				title: '英文名',
				dataIndex: 'english_name',
				key: 'english_name',
				className: "table-global-head-small",
				sorter: false
			}, {
				title: '班次名称',
				dataIndex: 'sequence_time',
				key: 'sequence_time',
				className: "table-global-head-5x",
				sorter: false
			}, {
				title: '日期',
				dataIndex: 'record_date',
				key: 'record_date',
				className: "table-global-head-short",
				sorter: false
			}, {
				title: '星期',
				dataIndex: 'record_date_weekday',
				key: 'record_date_weekday',
				className: "table-global-head-small"
			}, {
				title: '实际开始时间',
				dataIndex: 'on_time',
				key: 'on_time',
				className: "table-global-head-6x",
				sorter: false
			}, {
				title: '实际结束时间',
				dataIndex: 'off_time',
				key: 'off_time',
				className: "table-global-head-6x",
				sorter: false
			}, {
				title: '迟到时间',
				dataIndex: 'late_hours',
				key: 'late_hours',
				className: "table-global-head-small",
				sorter: false
			}, {
				title: '早退时间',
				dataIndex: 'early_exit_hours',
				key: 'early_exit_hours',
				className: "table-global-head-small",
				sorter: false
			},
			//  {
			// 	title: '矿工时长',
			// 	dataIndex: 'stayaway_work_hours',
			// 	key: 'stayaway_work_hours',
			// 	className: "table-global-head-5x",
			// 	sorter: false
			// }, 
			{
				title: '异常说明',
				dataIndex: 'tags',
				key: 'tags',
				className: "table-global-head-small",
				sorter: false,
				// render: text => "正常" === text ? text : <span style={{ color: "red" }}>{text}</span>
				render: tags => (
					<span>
						{tags.map(tag => {
							if (tag) {
								let color = "";
								if (tag === '上班未打卡' || tag === '下班未打卡' || tag === '旷工' || tag === '迟到' || tag === '早退') {
									color = 'red';
								}
								return <Tag color={color} key={tag}>{tag}</Tag>;
							}
						})}
					</span>
				),
			},
			//  {
			// 	title: '实际上班时长',
			// 	dataIndex: 'actual_work_hours',
			// 	key: 'actual_work_hours',
			// 	className: "table-global-head-7x",
			// 	sorter: false
			// }, 
			{
				title: '普通加班',
				dataIndex: 'normal_overtimes',
				key: 'normal_overtimes',
				className: "table-global-head-small",
				sorter: false
			}, {
				title: '因公加班',
				dataIndex: 'business_overtimes',
				key: 'business_overtimes',
				className: "table-global-head-small",
				sorter: false
			}, {
				title: '普通调休',
				dataIndex: 'normal_relaxation',
				key: 'normal_relaxation',
				className: "table-global-head-small",
				sorter: false
			}, {
				title: '因公调休',
				dataIndex: 'busniess_relaxation',
				key: 'busniess_relaxation',
				className: "table-global-head-small",
				sorter: false
			}, {
				title: '请假',
				dataIndex: 'leave_hours',
				key: 'leave_hours',
				className: "table-global-head-small",
				sorter: false
			}, {
				title: '请假类型',
				dataIndex: 'leave_type_str',
				key: 'leave_type_str',
				className: "table-global-head-small",
				sorter: false
			}, {
				title: '部门',
				dataIndex: 'department_name',
				key: 'department_name',
				className: "table-global-head",
				sorter: false
			}];

		const exceptionColumns = [
			{
				title: '操作',
				dataIndex: 'action',
				key: 'action',
				className: "table-global-head-small",
				render: (text, record, index) => this.props.access.attendanceRecord.u_value &&
					<div>
						<Button icon="edit" size="small" className="row-action-btn" disabled={!record.can_retroactive} onClick={this.showMakeupE.bind(this, record)}>补录</Button>
						<Button icon="edit" size="small" className="row-action-btn" onClick={this.updateManagementCurrent.bind(this, record.management_id)}>修改班次</Button></div>
			},
			{
				title: '月份',
				dataIndex: 'year_month',
				key: 'year_month',
				className: "table-global-head-small",
				sorter: false
			},
			{
				title: '工号',
				dataIndex: 'job_number',
				key: 'job_number',
				className: "table-global-head-small",
				sorter: false
			}, {
				title: '中文名',
				dataIndex: 'employee_name',
				key: 'employee_name',
				className: "table-global-head-small	",
				sorter: false
			}, {
				title: '英文名',
				dataIndex: 'english_name',
				key: 'english_name',
				className: "table-global-head-small",
				sorter: false
			}, {
				title: '班次名称',
				dataIndex: 'sequence_time',
				key: 'sequence_time',
				className: "table-global-head-5x",
				sorter: false
			}, {
				title: '日期',
				dataIndex: 'record_date',
				key: 'record_date',
				className: "table-global-head-short",
				sorter: false
			}, {
				title: '星期',
				dataIndex: 'record_date_weekday',
				key: 'record_date_weekday',
				className: "table-global-head-small"
			}, {
				title: '实际开始时间',
				dataIndex: 'on_time',
				key: 'on_time',
				className: "table-global-head-6x",
				sorter: false
			}, {
				title: '实际结束时间',
				dataIndex: 'off_time',
				key: 'off_time',
				className: "table-global-head-6x",
				sorter: false
			}, {
				title: '迟到时间',
				dataIndex: 'late_hours',
				key: 'late_hours',
				className: "table-global-head-small",
				sorter: false
			}, {
				title: '早退时间',
				dataIndex: 'early_exit_hours',
				key: 'early_exit_hours',
				className: "table-global-head-small",
				sorter: false
			},
			{
				title: '异常说明',
				dataIndex: 'tags',
				key: 'tags',
				className: "table-global-head-small",
				sorter: false,
				render: tags => (
					<span>
						{tags.map(tag => {
							if (tag) {
								let color = "red";
								return <Tag color={color} key={tag}>{tag}</Tag>;
							}
						})}
					</span>
				),
			}]

		const formatdate = 'HH:mm';
		const data = [];
		for (let i = 0; i < 3; i++) {
			data.push({
				key: i,
				name: 'John Brown',

				gender: 'M',
			});
		}

		return (
			<div className="app-module-item">

				<Tabs onChange={this.changeTabs} type="card">
					<Tabs.TabPane tab="考勤记录" key="tab0">
						<Modal width="800px"
							visible={this.state.makeupStatus}
							title="考勤补录"
							destroyOnClose={true}
							onCancel={this.cancelMakeup}
							footer={null}>
							<div style={{ textAlign: "center", margin: "20px 0px 20px" }}>

								<div>


									<Row style={{ margin: "5px" }}>
										<Col md={8} style={{ margin: "5px", textAlign: "right" }}>补录日期：</Col>
										<Col md={14} style={{ textAlign: "left" }}>
											<DatePicker defaultValue={this.state.makeupModel.record_date ? moment(this.state.makeupModel.record_date, dateFormat) : null} format={dateFormat} onChange={this.setMakeupDate} style={{ width: "200px" }}
												disabled />
											{/* disabled={this.state.MakeupColletion.disable_start || this.state.MakeupColletion.disable_end} */}
										</Col>
									</Row>
									<Row style={{ margin: "5px" }}>
										<Col md={8} style={{ margin: "5px", textAlign: "right" }}>班次上班时间：</Col>
										<Col md={14} style={{ textAlign: "left" }}>
											{/* <TimePicker minuteStep={30} defaultValue={this.state.makeupModel.on_time ? moment(this.state.makeupModel.on_time) : null} format={formatdate} onChange={this.setMakeupOnTime}/> disabled={this.state.MakeupColletion.disable_start} />*/}
											<TimePicker minuteStep={30} defaultValue={this.state.makeupModel.management_on_time ? moment(this.state.makeupModel.management_on_time) : null} format={formatdate} onChange={this.setMakeupManagementOnTime.bind(this)} />
										</Col>
									</Row>
									<Row style={{ margin: "5px" }}>
										<Col md={8} style={{ margin: "5px", textAlign: "right" }}>班次下班时间：</Col>
										<Col md={14} style={{ textAlign: "left" }}>
											{/* <TimePicker minuteStep={30} defaultValue={this.state.makeupModel.on_time ? moment(this.state.makeupModel.on_time) : null} format={formatdate} onChange={this.setMakeupOnTime}/> disabled={this.state.MakeupColletion.disable_start} />*/}
											<TimePicker minuteStep={30} defaultValue={this.state.makeupModel.management_off_time ? moment(this.state.makeupModel.management_off_time) : null} format={formatdate} onChange={this.setMakeupManagementOffTime.bind(this)} />
										</Col>
									</Row>
									<Row style={{ margin: "5px" }}>
										<Col md={8} style={{ margin: "5px", textAlign: "right" }}>上班时间：</Col>
										<Col md={14} style={{ textAlign: "left" }}>
											{/* <TimePicker minuteStep={30} defaultValue={this.state.makeupModel.on_time ? moment(this.state.makeupModel.on_time) : null} format={formatdate} onChange={this.setMakeupOnTime}/> disabled={this.state.MakeupColletion.disable_start} />*/}
											<TimePicker  defaultValue={this.state.makeupModel.on_time ? moment(this.state.makeupModel.on_time) : null} format={formatdate} onChange={this.setMakeupOnTime.bind(this)} />
										</Col>
									</Row>
									<Row style={{ margin: "5px" }}>
										<Col md={8} style={{ margin: "5px", textAlign: "right" }}>下班时间：</Col>
										<Col md={14} style={{ textAlign: "left" }}>

											<TimePicker  defaultValue={this.state.makeupModel.off_time ? moment(this.state.makeupModel.off_time) : null} format={formatdate} onChange={this.setMakeupOffTime.bind(this)} />
											{/* disabled={this.state.MakeupColletion.disable_end} /> */}

										</Col>
									</Row>
									<Row style={{ margin: "5px" }}>
										<Col md={8} style={{ margin: "5px", textAlign: "right" }}>补录原因：</Col>
										<Col md={14} style={{ textAlign: "left" }}>

											{this.state.MakeupColletion.reason_list.length > 0 &&
												<Select onChange={this.setMakeupReason} style={{ width: "200px" }} value={this.state.makeupModel.supplement_reason ? String(this.state.makeupModel.supplement_reason) : ''}>
													{this.state.MakeupColletion.reason_list.map(reason =>
														<Option key={reason.value} value={reason.value}>{reason.text}</Option>)}
												</Select>}
										</Col>
									</Row>
									<Row style={{ margin: "5px" }}>
										<Col md={8} style={{ margin: "5px", textAlign: "right" }}>补录备注：</Col>
										<Col md={14} style={{ textAlign: "left" }}>
											<TextArea style={{ width: "400px" }} value={this.state.makeupModel.remark} onChange={this.setMakeupRemark} />
										</Col>
									</Row>
								</div>
								<div style={{ marginTop: "40px" }}>
									<Button type="primary" style={{ marginTop: "20px" }} onClick={this.saveMakeup}>
										<span>保存</span>
									</Button>
								</div>
							</div>
						</Modal>
						<Modal width="800px"
							visible={!!this.state.importModalStatus}
							title="导入考勤模版"
							destroyOnClose={true}
							onCancel={() => this.setState({ importModalStatus: false })}
							footer={<Button type="back"
								onClick={() => this.setState({ importModalStatus: false })}>关闭</Button>}>
							<div style={{ textAlign: "center", margin: "20px 0px 20px" }}>
								<div>
									<Button type="primary" onClick={this.downloadTemplate}>
										<Icon type="cloud-download-o" />
										<span>下载模板</span>
									</Button>
								</div>
								<div style={{ marginTop: "40px" }}>
									<div>导入文件</div>
									<Input type="file" style={{ height: "38px" }} onChange={this.setUploadedFile} />
									<Button type="primary" style={{ marginTop: "20px" }} onClick={this.uploadFile}>
										<Icon type="cloud-upload-o" />
										<span>开始导入</span>
									</Button>
								</div>
							</div>
						</Modal>
						<Modal width="601px"
							visible={this.state.currentSchedule}
							title="修改班次"
							destroyOnClose={true}
							onCancel={this.closeCurrentSchedule.bind(this)}
							onOk={this.postCurrentSchedule.bind(this)}>
							<div className="Applys">
								<FormItem>
									<span style={{ display: "inline-block", width: "100px" }}>修改范围:&nbsp;</span>
									<RadioGroup value={this.state.typeTag} onChange={this.changeAllMember.bind(this)}>
										<RadioButton value="3">选择全部</RadioButton>
										<RadioButton value="1">选择员工</RadioButton>
										<RadioButton value="2">选择部门</RadioButton>
									</RadioGroup>
								</FormItem>
								{this.state.typeTag === '1' &&
									<Form.Item>
										<span style={{ display: "inline-block", width: "100px" }}>选择员工:&nbsp;</span>
										<Select
											mode="multiple"
											filterOption={false}
											style={{ width: 300 }}
											placeholder="请选择员工"
											onSearch={this.handleSearchChange}
											onChange={this.handleSelectChange}>
											{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
												this.props.employeeManagement.employeeList.Data.map(employee => {
													return (
														<Select.Option key={employee.id} value={employee.id}
															style={{ width: "290px" }}>
															{employee.real_name}
														</Select.Option>)
												})}
										</Select>
									</Form.Item>}
								{"2" === this.state.typeTag &&departmentsList &&
									<FormItem>
										<span style={{ display: "inline-block", width: "100px" }}>选择部门:&nbsp;</span>
										<TreeSelect style={{ width: "300px" }}
											placeholder="请选择部门"
											showSearch={false}
											autoExpandParent={true}
											value={this.state.attendanceDepartment}
											onChange={this.changeAttendanceDepartment.bind(this)}
											dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
											treeDefaultExpandAll>
											{this.renderTreeNodes(departmentsList)} 
										</TreeSelect>
									</FormItem>
								}
								<FormItem>
									<span style={{ display: "inline-block", width: "100px" }}>日期范围:&nbsp;</span>
									<RangePicker style={{ width: "300px" }} onChange={this.currentScheduleDataChange.bind(this)} />
								</FormItem>

								<FormItem>
									<span style={{ display: "inline-block", width: "100px" }}>班次:&nbsp;</span>
									<Select style={{ width: '300px' }}
										mode="combobox"
										filterOption={false}
										onChange={this.changeSchedule}
										onSelect={this.selectSchedule}>
										<Select.Option key={false} value="0">休息日</Select.Option>
										{this.props.attendance.attendanceTemplate.schedules &&
											this.props.attendance.attendanceTemplate.schedules.map(v => (
												<Select.Option key={v.sequence} value={v.sequence + ""}>
													{v.on_time + "-" + v.off_time}
												</Select.Option>)
											)
										}
									</Select>
								</FormItem>

							</div>
						</Modal>
						<Modal width="800px"
							visible={this.state.currentModalStatus}
							title="考勤记录"
							destroyOnClose={true}
							onCancel={this.closeCurrentModal}
							onOk={this.submitCurrentModal}>
							<div style={{ textAlign: "", margin: "10px 20px" }}>
								{this.state.currentData &&
									<Form onSubmit={this.submitCurrentModal} className="login-form" layout="inline">
										<div className="attendanceRecordLayout">
											<FormItem className="attendanceRecordLayout-item">
												员工姓名：{this.state.currentData.employee_name}
											</FormItem>
											<FormItem className="attendanceRecordLayout-item">
												部门：{this.state.currentData.department_name}
											</FormItem>
											<FormItem className="attendanceRecordLayout-item">
												日期：{this.state.currentData.record_date}
											</FormItem>
										</div>
										<div className="attendanceRecordLayout">
											<div className="left-formItem">
												<FormItem>
													实际开始时间：
										{this.props.form.getFieldDecorator('on_time', {
														rules: [{ required: false }],
														initialValue: this.state.currentData.on_time ? moment(this.state.currentData.on_time, format) : null
													})(<TimePicker minuteStep={30} style={{ width: "200px" }} />)}
												</FormItem>
												<FormItem>
													实际上班时长：
										{this.props.form.getFieldDecorator('actual_work_hours', {
														rules: [{ required: false }],
														initialValue: this.state.currentData.actual_work_hours
													})(<Input style={{ width: "200px" }} />)}
												</FormItem>
												<FormItem>
													普通加班：
										{this.props.form.getFieldDecorator('normal_overtimes', {
														rules: [{ required: false }],
														initialValue: this.state.currentData.normal_overtimes
													})(<Input style={{ width: "200px" }} />)}
												</FormItem>
												<FormItem>
													普通调休：
										{this.props.form.getFieldDecorator('normal_relaxation', {
														rules: [{ required: false }],
														initialValue: this.state.currentData.normal_relaxation
													})(<Input style={{ width: "200px" }} />)}
												</FormItem>
												<FormItem>
													迟到时间：
										{this.props.form.getFieldDecorator('late_hours', {
														rules: [{ required: false }],
														initialValue: this.state.currentData.late_hours
													})(<Input style={{ width: "200px" }} />)}
												</FormItem>
											</div>
											<div className="right-formItem">
												<FormItem>
													实际结束时间：
										{this.props.form.getFieldDecorator('off_time', {
														rules: [{ required: false }],
														initialValue: this.state.currentData.off_time ? moment(this.state.currentData.off_time, format) : null
													})(<TimePicker minuteStep={30} style={{ width: "200px" }} />)}
												</FormItem>
												<FormItem>
													矿工时长：
										{this.props.form.getFieldDecorator('stayaway_work_hours', {
														rules: [{ required: false }],
														initialValue: this.state.currentData.stayaway_work_hours
													})(<Input style={{ width: "200px" }} />)}
												</FormItem>
												<FormItem>
													因公加班：
								        {this.props.form.getFieldDecorator('business_overtimes', {
														rules: [{ required: false }],
														initialValue: this.state.currentData.business_overtimes
													})(<Input style={{ width: "200px" }} />)}
												</FormItem>
												<FormItem>
													因公调休：
										{this.props.form.getFieldDecorator('busniess_relaxation', {
														rules: [{ required: false }],
														initialValue: this.state.currentData.busniess_relaxation
													})(<Input style={{ width: "200px" }} />)}
												</FormItem>
												<FormItem>
													早退时间：
										{this.props.form.getFieldDecorator('early_exit_hours', {
														rules: [{ required: false }],
														initialValue: this.state.currentData.early_exit_hours
													})(<Input style={{ width: "200px" }} />)}
												</FormItem>
											</div>
										</div>
										<div className="attendanceRecordLayout">
											<FormItem className="bottom-formItem">
												<div style={{ float: 'left', paddingTop: '5px' }}>异常说明：</div>
												<div className="err-description">
													{this.props.form.getFieldDecorator('exception_description', {
														rules: [{ required: false }],
														initialValue: this.state.currentData.exception_description
													})(<TextArea rows={4} style={{ display: 'block', width: '100%' }} />)}
												</div>
											</FormItem>
										</div>
									</Form>
								}
							</div>
						</Modal>

						

						<div style={{ marginBottom: "20px" }}>
							{this.props.access.attendanceRecord.import_value && <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
								<Button type="primary" onClick={() => this.setState({ importModalStatus: true })}>
									<Icon type="cloud-upload-o" />
									<span>导入</span>
								</Button>
							</div>}
							<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
								<DatePicker.MonthPicker onChange={this.setMonthFilter}
									placeholder="请选择导出/审核年月" />
							</div>
							{this.props.access.attendanceRecord.export_value && <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
								<Button type="primary" onClick={this.exportAttendanceRecord.bind(this)}>
									<Icon type="cloud-download-o" />
									<span>导出</span>
								</Button>

								{/* <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<Button type="primary" onClick={this.reviewAttendanceRecord.bind(this)}>
										<Icon type="calendar" />
										<span>审核</span>
									</Button>
								</div> */}
							</div>}


							<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>

								<Button type="primary" onClick={this.showCurrentSchedule.bind(this)}>
									<Icon type="calendar" />
									<span>修改班次</span>
								</Button>

							</div>


							<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
								<Button type="primary" onClick={this.showMakeup}>
									<Icon type="calendar" />
									<span>批量补录</span>
								</Button>
							</div>
							{/* <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
								<Button type="primary" onClick={this.adjustSchedule.bind(this)}>
									<Icon type="calendar" />
									<span>统一休息日设置</span>
								</Button>
							</div> */}

							{this.props.webCurrentUser.currentUser.IsAdmin &&
								<div>
									<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px", visibility: "hidden" }}>

										<Button type="primary" onClick={this.showMakeup2}>
											<Icon type="calendar" />
											<span>超管补录</span>
										</Button>
									</div>
									<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
										<DatePicker onChange={this.handleSyncAttendanceDateChange} style={{ width: 120 }} />
									</div>
									<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
										<Button type="primary" onClick={this.syncAttendanceRecord}>
											<Icon type="calendar" />
											<span>同步考勤</span>
										</Button>
									</div>
								</div>
							}
							<div style={{ clear: "both" }}></div>
							<div className="colAction" style={{ margin: "0px 10px 10px 0px" }}>

								<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<span style={{ marginRight: "5px" }}>校区 : </span>
									<Select style={{ width: "200px" }} onChange={this.setCampusFilter}>
										<Select.Option key={0} value={0}></Select.Option>
										<Select.Option key={1} value={1}>{'华山校HS'}</Select.Option>
										<Select.Option key={2} value={2}>{'中星城校ZXC'}</Select.Option>
										<Select.Option key={3} value={3}>{'时光里校SGL'}</Select.Option>
										<Select.Option key={4} value={4}>{'晶耀前滩校JYC'}</Select.Option>
									</Select>
								</div>

								{departmentsList ?
									<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
										<TreeSelect style={{ minWidth: "200px" }}
											placeholder="请选择部门"
											showSearch={false}
											autoExpandParent={true}
											dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
											treeDefaultExpandAll
											value={this.state.department_id}
											onChange={this.onSelectTreeChange.bind(this)}>
											{this.renderTreeNodes(departmentsList)}
										</TreeSelect>
									</div>
									:
									<Spin />
								}

								<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<span style={{ marginRight: "5px" }}>日期 : </span>
									<DatePicker onChange={this.handleDatePickerStartChange} style={{ width: 120 }} />
								</div>
								<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<span style={{ marginRight: "5px" }}> 至 </span>
									<DatePicker onChange={this.handleDatePickerEndChange} style={{ width: 120 }} />
								</div>


								<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<Select style={{ width: 100 }} placeholder="员工状态" onChange={this.onSelectStatusChange.bind(this)}>
										<Select.Option value="0">离职</Select.Option>
										<Select.Option value="1">在职</Select.Option>
										<Select.Option value="2">试用</Select.Option>
										<Select.Option value="3">兼职</Select.Option>
									</Select>
								</div>



								<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<Input.Search
										placeholder="报告人 工号/姓名"
										onSearch={this.setEmployeeFilter}
										style={{ width: 180 }}
										defaultValue={null}
										enterButton />
								</div>
							</div>


							<div style={{ clear: "both" }}></div>
							{/*考勤记录列表*/}
							<Table columns={columns} dataSource={this.props.attendance.attendanceRecordData}
								pagination={{
									total: this.props.attendance.attendanceRecordTotalPage,
									defaultCurrent: 1,
									pageSize: this.props.attendance.attendanceRecordPageSize,
									current: this.props.attendance.attendanceRecordPage
								}}
								scroll={{ x: 1010 }}
								onChange={this.fetchAttendanceRecord.bind(this)}
								rowKey={(record, index) => index}
								rowSelection={this.rowSelection}
							/>
						</div>
					</Tabs.TabPane>
					<Tabs.TabPane tab="异常处理" key="tab1">
						<div style={{ marginBottom: "20px" }}>

							<Modal width="800px"
								visible={this.state.managementModalStatus}
								title="排班修改"
								destroyOnClose={true}
								onCancel={this.closeManagementCurrent}
								onOk={this.submitManagementCurrentModal}>
								<div style={{ textAlign: "center" }}>
									{this.state.currentData &&
										<Form onSubmit={this.submitManagementCurrentModal} className="login-form" layout="inline">
											<div>
												<Form.Item label="员工姓名" className='attendance-template'>
													<Input style={{ width: "300px" }} disabled={true}
														value={this.state.currentData.real_name} />
												</Form.Item>
											</div>
											<div>
												<Form.Item label="上班日期" className='attendance-template'>
													<Input style={{ width: "300px" }} disabled={true}
														value={this.state.currentData.attendance_date} />
												</Form.Item>
											</div>
											<div>
												<Form.Item label="模版班次" className='attendance-template'>
													<Select style={{ width: '300px' }}
														mode="combobox"
														filterOption={false}
														onChange={this.changeManagementSchedule}
														onSelect={this.selectManagementSchedule}
														defaultValue={this.state.currentData.schedule_id + ''}>
														<Select.Option key={false} value="0">休息日</Select.Option>
														{this.props.attendance.attendanceTemplate.schedules &&
															this.props.attendance.attendanceTemplate.schedules.map(v => (
																<Select.Option key={v.sequence} value={v.sequence + ""}>
																	{v.on_time + "-" + v.off_time}
																</Select.Option>)
															)
														}
													</Select>
												</Form.Item>
											</div>
										</Form>}
								</div>
							</Modal>

							<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
								<Button type="primary" onClick={this.exportAttendanceExceptionRecord.bind(this)}>
									<Icon type="cloud-download-o" />
									<span>导出</span>
								</Button>
							</div>

							<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>

								<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<span style={{ marginRight: "5px" }}>校区 : </span>
									<Select style={{ width: "200px" }} onChange={this.setCampusFilter2}>
										<Select.Option key={0} value={0}></Select.Option>
										<Select.Option key={1} value={1}>{'华山校HS'}</Select.Option>
										<Select.Option key={2} value={2}>{'中星城校ZXC'}</Select.Option>
										<Select.Option key={3} value={3}>{'时光里校SGL'}</Select.Option>
										<Select.Option key={4} value={4}>{'晶耀前滩校JYC'}</Select.Option>
									</Select>
								</div>
								{departmentsList ?
									<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
										<TreeSelect style={{ minWidth: "200px" }}
											placeholder="请选择部门"
											showSearch={false}
											autoExpandParent={true}
											dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
											treeDefaultExpandAll
											value={this.state.exceptionFilter.department_id}
											onChange={this.onSelectTreeChange2.bind(this)}>
											{this.renderTreeNodes(departmentsList)}
										</TreeSelect>
									</div>
									:
									<Spin />
								}
								<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<span style={{ marginRight: "5px" }}>日期 : </span>
									<DatePicker onChange={this.handleDatePickerStartChange2} style={{ width: 120 }} />
								</div>
								<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<span style={{ marginRight: "5px" }}> 至 </span>
									<DatePicker onChange={this.handleDatePickerEndChange2} style={{ width: 120 }} />
								</div>
								<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<Select style={{ width: 100 }} placeholder="状态" onChange={this.onSelectAttendanceStatusChange.bind(this)}>
										<Select.Option value="">全部</Select.Option>
										<Select.Option value="1">迟到</Select.Option>
										<Select.Option value="2">早退</Select.Option>
										<Select.Option value="4">旷工</Select.Option>
									</Select>
								</div>
								<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<Input.Search
										placeholder="报告人 工号/姓名"
										onSearch={this.setEmployeeFilter2}
										style={{ width: 180 }}
										defaultValue={null}
										enterButton />
								</div>
							</div>
							<div style={{ clear: "both" }}></div>
							{/*异常考勤记录列表*/}
							<Table columns={exceptionColumns} dataSource={this.props.attendance.exceptionAttendanceRecordData}
								loading={this.state.isloading2}
								pagination={{
									total: this.props.attendance.exceptionAttendanceRecordTotalPage,
									defaultCurrent: 1,
									pageSize: this.props.attendance.exceptionAttendanceRecordPageSize,
									current: this.props.attendance.exceptionAttendanceRecordPage
								}}
								scroll={{ x: 1010 }}
								onChange={this.fetchExceptionAttendanceRecord.bind(this)}
								rowKey={(record, index) => index}
							/>
						</div>
					</Tabs.TabPane>
				</Tabs>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		attendance: state.attendance,
		departmentStructure: state.departmentStructure,
		employeeManagement: state.employeeManagement,
	}
}

const mapDispatchToProps = {
	fetchAttendanceRecord,
	updateAttendanceRecord,
	exportAttendanceRecord,
	exportAttendanceExceptionRecord,
	fetchDepartmentsList,
	reviewAttendanceRecord,
	fetchEmployeesList,
	fetchAttendanceSchedule,
	fetchExceptionAttendanceRecord,
	updateCrewRostering,
}


AttendanceRecord = Form.create()(AttendanceRecord);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(AttendanceRecord));











// WEBPACK FOOTER //
// ./src/routes/Attendance/AttendanceRecord.js